import type { SetsConfig, SetsState } from '@/types/sports/sets';

export const setCount = (config: SetsConfig): number =>
  2 * config.sets_to_win - 1;

export const setNumber = (state: SetsState): number => state.sets.length + 1;

export const currentSetLabel = (state: SetsState, swapped = false): string => {
  const { home_team, away_team } = state.current_set;

  return swapped
    ? `${away_team} : ${home_team}`
    : `${home_team} : ${away_team}`;
};
